import { Alert, AlertModal } from '../../..'
import { observer } from 'mobx-react-lite'
import { Icons } from '../../../misc/Icons'
import { store } from '../../../stores/Store'
import PanelBody from '../../layout/PanelBody'
import PanelHeader from '../../layout/PanelHeader'
import { Button, IconButton } from '@mui/material'
import ErrorBoundary from '../../../misc/ErrorBoundary'
import React from 'react'
import Ajax from '../../../Ajax'
import CaseSummaryTable from './CaseSummaryTable'
import Field from '../../form/fields/Field'
import InlineMenu from '../../../misc/InlineMenu'


export default observer(function CaseSummaryTool () {
    
    const { loading, loadCaseSummary, loadWorkflowSummary, setSearchString, searchString, getCaseSummaryTable, downloadCaseSummaryCsv, accountUid, setAccountUid } = store.UsageStore

    React.useEffect(() => {
        loadCaseSummary()
    }, [])
    
    return (
        <ErrorBoundary>
            <div className="panel panel-dark">
                <PanelHeader>
                    <div style={{display: "flex", gap: "10px", flexFlow: "wrap", alignItems: "center"}}>
                        <h2>Case summary</h2>

                        <div className="form-search form-search-dark">
                            <input 
                                autoFocus 
                                value={searchString}
                                placeholder="Search"
                                spellCheck="false"
                                onChange={(e) => {
                                    setSearchString(e.target.value)
                                }} />
                        </div>

                        <Button
                            color="secondary"
                            variant="contained"
                            className="btn btn-sm"
                            onClick={() => loadCaseSummary()}>
                            <Icons.Refresh /> Refresh
                        </Button>

                        {/* <Button
                            color="secondary"
                            variant="contained"
                            className="btn btn-sm"
                            onClick={() => loadWorkflowSummary()}>
                            <Icons.Refresh /> Load workflow summary
                        </Button> */}

                        <Button
                            color="secondary"
                            variant="contained"
                            className="btn btn-sm"
                            disabled={!getCaseSummaryTable?.length}
                            onClick={() => downloadCaseSummaryCsv()}>
                            <Icons.Download /> Download
                        </Button>

                        {store.AppStore.checkJwtRole("sysuser") ? (
                            <InlineMenu>
                                <div style={{padding: "15px"}}>
                                    <Field.Select 
                                        formik
                                        placeholder="Select an account"
                                        helpText="Results will include Cases from this account and all child accounts."
                                        value={accountUid} 
                                        warning={false}
                                        disabled={loading}
                                        onChange={(e) => {
                                            setAccountUid(e.target.value)
                                            loadCaseSummary()
                                        }}
                                        style={{maxWidth: "200px"}}
                                        options={store.NodeStore.accounts.filter(account => account.accountType === "customer").map((account => {
                                            return {value: account.uid, label: account.label}
                                        }))} />
                                </div>
                            </InlineMenu>
                        ) : null}
                    </div>
                    
                    <IconButton color="info" style={{margin: "0 0 auto auto"}} size="small" onClick={() => store.ToolStore.setTool(null)}><Icons.X /></IconButton>
                </PanelHeader>
                
                <PanelBody>
                    <CaseSummaryTable />
                </PanelBody>
            </div>
        </ErrorBoundary>
    )
})